type ComponentNameProps = {
  name?: string;
  requestedName?: string;
};

const ProductComponentName = ({ name, requestedName }: ComponentNameProps): JSX.Element | null => {
  return (
    <div className='flex flex-column justify-content-center'>
      <div className='font-normal max-w-fit'>{name}</div>

      {requestedName && (
        <div className='white-space-nowrap overflow-hidden text-overflow-ellipsis w-full font-normal font-italic text-gray-600 line-height-2'>
          {requestedName}
        </div>
      )}
    </div>
  );
};

export default ProductComponentName;
